import { useProduct } from '@/entities/product';

export const useRatings = () => {
    const { product } = useProduct();
    const reviewCount = product?.rating.count ?? 0;

    const reviewWord = reviewCount === 1 ? 'review' : 'reviews';
    const reviewsText = reviewCount > 0 ? `${reviewCount} ${reviewWord}` : 'Be the first to review';

    return { average: product?.rating.average, reviewsText };
};
